import { NavLink } from 'react-router-dom';

import logoICIAR from '../assets/img/ICIAR-LOGO.png'

const Footer = () => {
  return (
    <div className='container-fluid'>
      <footer className="row py-5 border-top">
        <div className="col">
          <NavLink to="/" className="d-flex justify-content-center align-items-center mb-3 link-dark text-decoration-none">
            <img src={logoICIAR} alt="..." width={100} className="img-responsive" />
          </NavLink>
          <p className="text-muted text-center "> © Insitutos Gto. 2022 </p>
        </div>

        {/* <div className="col">
          
        </div> */}

        <div className="col">
          <h5>ICIAR NACIONAL</h5>
          <ul className="nav flex-column">
            <li className="nav-item mb-2"><a href="https://iciar.org/" target='_blank' rel="noopener noreferrer" className="nav-link p-0 text-muted"> ICIAR </a></li>
            <li className="nav-item mb-2"><a href="https://www.youtube.com/user/mediosiciar" target='_blank' rel="noopener noreferrer" className="nav-link p-0 text-muted"> ICIAR YouTube </a></li>
            <li className="nav-item mb-2"><a href="https://web.facebook.com/mediosiciar" target='_blank' rel="noopener noreferrer" className="nav-link p-0 text-muted"> ICIAR Facebook </a></li>
            <li className="nav-item mb-2"><a href="https://papiro52.com/" target='_blank' rel="noopener noreferrer" className="nav-link p-0 text-muted">Papiro 52</a></li>
            <li className="nav-item mb-2"><a href="https://www.facebook.com/libreriaspapiro52/" target='_blank' rel="noopener noreferrer" className="nav-link p-0 text-muted">Papiro 52 Facebook</a></li>
          </ul>
        </div>

        <div className="col">
          <h5>ICIAR Gto.</h5>
          <ul className="nav flex-column">
            <li className="nav-item mb-2"><a href="https://www.facebook.com/mediosiciargto" target='_blank' rel="noopener noreferrer" className="nav-link p-0 text-muted">ICIAR Gto Facebook</a></li>
            <li className="nav-item mb-2"><a href="https://www.youtube.com/channel/UC134b2tP0b0k8jjcnxQ3WmA" target='_blank' rel="noopener noreferrer" className="nav-link p-0 text-muted">ICIAR GTO YouTube</a></li>
            {/* <li className="nav-item mb-2"><a href="" target='_blank' rel="noopener noreferrer" className="nav-link p-0 text-muted">Pricing</a></li>
            <li className="nav-item mb-2"><a href="" target='_blank' rel="noopener noreferrer" className="nav-link p-0 text-muted">FAQs</a></li>
            <li className="nav-item mb-2"><a href="" target='_blank' rel="noopener noreferrer" className="nav-link p-0 text-muted">About</a></li> */}
          </ul>
        </div>

        <div className="col">
          <h5>Menu</h5>
          <ul className="nav flex-column">
            <li className="nav-item mb-2"><NavLink to="/public/home" className="nav-link p-0 text-muted">Inicio</NavLink></li>
            <li className="nav-item mb-2"><NavLink to="/public/aboutus" className="nav-link p-0 text-muted">Nosotros</NavLink></li>
            <li className="nav-item mb-2"><NavLink to="/public/advertisements" className="nav-link p-0 text-muted">Anuncios</NavLink></li>
            <li className="nav-item mb-2"><NavLink to="/public/blogs" className="nav-link p-0 text-muted">Blog</NavLink></li>
            <li className="nav-item mb-2"><NavLink to="/public/contact" className="nav-link p-0 text-muted">Contacto</NavLink></li>
            <li className="nav-item mb-2"><NavLink to="#" className="nav-link p-0 text-muted">Institución</NavLink></li>
          </ul>
        </div>
      </footer>
    </div>
  )
}

export default Footer;